import React, { useId, useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { SearchFloatingPanelProps } from './SearchFloatingPanel'
import SearchFloatingPanel from './SearchFloatingPanel'
import TourV2SearchGroupItems from 'components/Search/TourV2/TourV2SearchGroupItems'
import { getTourGroupTypesList } from 'components/Search/TourV2/TourV2SearchGroupSelect'

interface Props extends Omit<
  SearchFloatingPanelProps,
  'title' | 'isConfirmButtonHidden' | 'children'
> {
  onClose: () => void
}

function TourGroupTypePanel(props: Props) {
  const intl = useIntl()
  const { onClose } = props
  const formId = useId()

  const tourGroupTypesList = useMemo(() => getTourGroupTypesList(intl), [intl])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onClose()
  }

  return (
    <SearchFloatingPanel
      {...props}
      title={intl.formatMessage({
        id: '/02TNw+Otd',
        defaultMessage: 'What type of journey?',
        description: 'Heading title for the tour group type selection panel',
      })}
      confirmText={intl.formatMessage({
        id: 'Fk0HDNRe//',
        defaultMessage: 'Apply',
        description: 'Confirm button label for tour group type selection',
      })}
    >
      <form onSubmit={onSubmit} id={formId}>
        <TourV2SearchGroupItems groupTypes={tourGroupTypesList} />
      </form>
    </SearchFloatingPanel>
  )
}

export default TourGroupTypePanel
